export const ServiceFee = {
    FEE: 'fee',
    PERCENTAGE: 'percentage'
}